<nav [ngClass]="{ 'sidebar-hidden': !showSidebar }" class="col-sm-3 hidden-xs-down bg-faded sidebar">
  <ul class="nav nav-pills flex-column">
    <li id='sidebarNavItems' class="nav-item" *ngFor="let item of routes" [ngStyle]="{ display: item.hide ? 'none' : 'block' }">
      <a
        class="nav-link"
        *ngIf="item.route && item.label"
        routerLink="{{ item.route }}"
        routerLinkActive
        #rla="routerLinkActive"
        [ngClass]="rla.isActive ? 'active' : ''"
        >{{ item.label }} <span *ngIf="0 < item.badge" class="badge badge-danger">{{ item.badge }}</span>
      </a>
      <a class="nav-link no-hover" *ngIf="!item.route && item.label">{{ item.label }}</a>
      <ul *ngIf="item.subRoutes" class="nav nav-pills flex-column">
        <li class="nav-item" *ngFor="let subItem of item.subRoutes">
          <a
            class="nav-link"
            *ngIf="subItem.route && subItem.label"
            routerLink="{{ subItem.route }}"
            routerLinkActive
            #rla="routerLinkActive"
            [ngClass]="rla.isActive ? 'active' : ''"
            >{{ subItem.label }}</a
          >
        </li>
      </ul>
    </li>
  </ul>
</nav>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/sidebar/sidebar.component.html